module.exports = __webpack_public_path__ + "img/edit-block-primary.ca97e36d.svg";